import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    Button,
    Typography
} from '@mui/material';
import { TIPOS_TRAMITE_PICKER, rutaIniciarTramite } from '../utils/rutasTramite';

// Picker de tipo de trámite para el listado unificado (/tramites), donde no hay un
// cliente en contexto: cada FormularioIniciarTramiteX ya resuelve la búsqueda de
// cliente por su cuenta cuando no recibe :cuil en la URL.
export default function ModalIniciarTramite({ open, onClose }) {
    const navigate = useNavigate();
    const [tipoSeleccionado, setTipoSeleccionado] = useState('');

    const cerrar = () => {
        onClose();
        setTipoSeleccionado('');
    };

    const confirmar = () => {
        const destino = rutaIniciarTramite(tipoSeleccionado);
        if (destino) navigate(destino);
        cerrar();
    };

    return (
        <Dialog
            open={open}
            onClose={cerrar}
            fullWidth
            maxWidth="sm"
            PaperProps={{ sx: { borderRadius: '16px', boxShadow: 'var(--shadow-lg)' } }}
        >
            <DialogTitle sx={{ fontWeight: 'bold', color: 'var(--primary)', display: 'flex', alignItems: 'center' }}>
                <i className="bi bi-bookmark-fill me-2" />
                Iniciar Trámite
            </DialogTitle>
            <DialogContent dividers sx={{ pt: 3 }}>
                <Typography sx={{ mb: 3 }}>
                    Seleccione el tipo de trámite a iniciar:
                </Typography>
                <Select
                    fullWidth
                    variant="outlined"
                    sx={{ borderRadius: '12px' }}
                    value={tipoSeleccionado}
                    onChange={(e) => setTipoSeleccionado(e.target.value)}
                >
                    {TIPOS_TRAMITE_PICKER.map((tipo) => (
                        <MenuItem key={tipo.nombreBackend} value={tipo.nombreBackend}>
                            <i className={`${tipo.icono} me-2`} /> {tipo.label}
                        </MenuItem>
                    ))}
                </Select>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 0, gap: 1 }}>
                <Button
                    onClick={cerrar}
                    sx={{ borderRadius: '20px', color: '#6b7280', textTransform: 'none', fontWeight: 600 }}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    disabled={!tipoSeleccionado}
                    onClick={confirmar}
                    sx={{
                        borderRadius: '20px',
                        textTransform: 'none',
                        background: 'var(--primary)',
                        boxShadow: 'var(--shadow-md)',
                        '&:hover': {
                            background: 'var(--primary)',
                            boxShadow: 'var(--shadow-md)'
                        }
                    }}
                >
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
